import { render, staticRenderFns } from "./BanerContainer.vue?vue&type=template&id=9a4a752e&scoped=true"
import script from "./BanerContainer.vue?vue&type=script&lang=js"
export * from "./BanerContainer.vue?vue&type=script&lang=js"
import style0 from "./BanerContainer.vue?vue&type=style&index=0&id=9a4a752e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4a752e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a4a752e')) {
      api.createRecord('9a4a752e', component.options)
    } else {
      api.reload('9a4a752e', component.options)
    }
    module.hot.accept("./BanerContainer.vue?vue&type=template&id=9a4a752e&scoped=true", function () {
      api.rerender('9a4a752e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/account/components/BanerContainer.vue"
export default component.exports